import {IActionBase} from "./IActionBase";

import React, {Component} from "react";

import {store} from "../../redux/storeConfig/store";
import {callPostService} from "../services/api_service";
import {ActionsManager} from "./actionsManager";
import {utils_ui} from "../utils/utils_ui";
// import {applyoo} from "../../App";


export class reloadCurrentPage extends Component implements IActionBase {

    actionCode = "reloadCurrentPage";
    actionName = "reloadCurrentPage";

    Execute = (prmActionParameters:any, prmActionsManager?:ActionsManager, prmElementObj?:any, prmData?:any)=> {

        // const timerId = setTimeout(() => {
        //     let queryName = "*";
        //     let pageDataObj = store.getState().store_PageData
        //
        //     let currPrimaryEntityID = store.getState().store_PageData.primaryEntityID;
        //     // let queryName: string = prmActionParameters?.queryName || prmActionParameters.QueryName; //prmActionParameters?.queryName;
        //     // if (!queryName) {
        //     //     queryName = "*";
        //     // }
        //
        //
        //     let currPageStruct = store.getState().store_PageStructure.pageStructure;
        //
        //     //let navUrl = `${currPageStruct.ProjectID}/${currPageStruct.PageCode}`
        //     let navUrl = `${currPageStruct.PageCode}`
        //
        //     let navUrlParams = ""
        //
        //     if (!!currPageStruct
        //         && !!currPageStruct.LstDataRequests
        //         && currPageStruct.LstDataRequests.length > 0) {
        //         let currDataRequestObj = currPageStruct.LstDataRequests[0];
        //
        //         //for (let ind01 = 0; ind01 < currPageStruct.LstDataRequests.length; ind01++) {
        //         //let currDataRequestObj = currPageStruct.LstDataRequests[ind01];
        //
        //         let lstWebFilters = currDataRequestObj.LstFilterElements.filter((prmItem:any) => {
        //             return prmItem.FilterValueSource == "url"
        //         })
        //
        //         for (const currWebFilter of lstWebFilters) {
        //             navUrlParams += `${currWebFilter.ConstValue}=${currPrimaryEntityID}`
        //         }
        //
        //         if (!!navUrlParams) {
        //             navUrl = `${navUrl}?${navUrlParams}`;
        //         }
        //
        //
        //         // if (queryName == "*"
        //         //     || currDataRequestObj.ResponseName == queryName) {
        //         //     let dicFilters = utils_ui.getDicFilterValues(currDataRequestObj.ResponseName);
        //         //
        //         //     let prmParamsObj = {
        //         //         "ProjectID": currPageStruct.ProjectID,
        //         //         "PageCode": currPageStruct.PageCode,
        //         //         "ResponseName": currDataRequestObj.ResponseName,
        //         //         "DicFilterValues": dicFilters,
        //         //         "LstFilters": []
        //         //     }
        //         //
        //         //     //localStorage[`QueryFilter_project_${prmParamsObj.ProjectID}_page_${prmParamsObj.PageCode}_query_${prmParamsObj.ResponseName}`] = JSON.stringify(dicFilters);
        //         //
        //         //     callPostService("clsSvc_DataRequest_Get", prmParamsObj).then((prmResponse: any) => {
        //         //         if (!!prmResponse?.reponseObj?.Data) {
        //         //             prmResponse.reponseObj.Data = utils_ui.parseAllDates(prmResponse?.reponseObj?.Data);
        //         //
        //         //             store.dispatch({type: 'SET_DATA',
        //         //                 projectID: currPageStruct.ProjectID,
        //         //                 data: prmResponse?.reponseObj?.Data,
        //         //                 responseObj: prmResponse?.reponseObj});
        //         //
        //         //             if (!!prmActionParameters?.callbackFunction){
        //         //                 prmActionParameters.callbackFunction(prmResponse?.reponseObj)
        //         //             }
        //         //         }
        //         //     })
        //         // }
        //         //}
        //
        //         store.dispatch({type:'NAVIGATE', currentLocation: navUrl});
        //
        //         // let lstActions = [{
        //         //     "ActionTypeCode": "executeQuery",
        //         //     "ActionParameters": {
        //         //         queryName: "*" //currDataRequestObj.ResponseName
        //         //     }
        //         // }];
        //         //
        //         // setTimeout(() => {
        //         //     prmActionsManager?.executeActions(lstActions, prmElementObj)
        //         //
        //         // }, 300)
        //     }
        //
        // }, 500)

    }

}
